function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#e94636;}.cls-1{fill-rule:evenodd;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M133.91,189.54h-46l-4.69-8.16h0L82.35,180,61.8,144.27l-.53-.91A8.55,8.55,0,0,1,62.63,133l23.29-24,5.56-5.73.35-.37a8.75,8.75,0,0,0,2.27-4,5.08,5.08,0,0,0,.15-.65A8.74,8.74,0,0,0,94.06,94a8.32,8.32,0,0,0-.3-.88,9.22,9.22,0,0,0-8.7-6H64l8.74-16L86.3,46.31c6.47-11.25,1.74-26.67-9.24-33l-.42-.24C71.33,32.89,66.23,51.77,61,71.14c-.36,1.32-.72,2.64-1.07,4q-1.62,6-3.23,12H46.81l4.28-16,7.77-29a23.27,23.27,0,0,0,.57-3c1.52-12.26-6.83-24.76-18.74-28V189.54H0V52.92H31.11V0A68.13,68.13,0,0,1,42.93,1.79,35.48,35.48,0,0,1,65,19.64L70.24,0A62.3,62.3,0,0,1,81.81,5.05c15.6,9,22.13,29.7,13,45.59l-1.63,2.84.25,0a43.18,43.18,0,0,1,19.85,8.79,45.13,45.13,0,0,1,10.14,11.16,44,44,0,0,1,6.23,15.61,43.05,43.05,0,0,1,.61,11.75,47.1,47.1,0,0,1-3.29,13.8,39.47,39.47,0,0,1-8.19,12.76l-13.15,13.42L128.34,180h0l.4.7Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M94.25,98.32A9.57,9.57,0,0,0,94.06,94,8.74,8.74,0,0,1,94.25,98.32Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M70,102a6.47,6.47,0,1,0-6.47,6.46A6.47,6.47,0,0,0,70,102Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M94.1,99a8.75,8.75,0,0,1-2.27,4A10.25,10.25,0,0,0,94.1,99Z"
});

var SvgRrFavicon = function SvgRrFavicon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 133.91 190.69",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRrFavicon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rr-favicon.6a456234.svg";
export { ForwardRef as ReactComponent };